import * as React from 'react'

const HorizontalSelector = ({ children }: { children: any }) => {
  return (
    <div className='relative flex justify-between'>
      {children}
      <div className='absolute z1 left-0 right-0 bottom-0' />
    </div>
  )
}

export default HorizontalSelector



// WEBPACK FOOTER //
// ./src/components/HorizontalSelector.tsx